module.exports = __webpack_public_path__ + "static/insert_legend_2-43991e9028bc00040f91dcd04b98b216.png";